var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Nav, Row, Tab } from "react-bootstrap";
import { AiFillCaretUp, AiFillCaretDown } from "react-icons/ai";
import { SlEqualizer } from "react-icons/sl";
import API from "../utils/routes";
import Filter from "./Filter";
import DataTable from "./DataTable";
import AlertBadge from "./AlertBadge";
import Pagination from "./Pagination";
import Modal from "./Modal";
import "../css/custom.css";
export const AlertsTable = ({ TokenManager, alertsBackendUrl, columns, queryParams, heading, mockedData }) => {
    var _a, _b, _c;
    const [isLoading, setIsLoading] = useState(false);
    const [alertsResponse, setAlertsResponse] = useState({
        results: [],
        meta: {
            pageNum: 1,
            numRecords: 1,
            totalNumRecords: 0,
            hasMoreRecords: false,
        }
    });
    const [alertsMeta, setAlertsMeta] = useState((_a = mockedData === null || mockedData === void 0 ? void 0 : mockedData.alertsMeta) !== null && _a !== void 0 ? _a : []);
    const [filtersInputs, setFiltersInput] = useState({});
    const [columnMeta, setColumnMeta] = useState([]);
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [perPageCount, setPerPageCount] = useState(10);
    const [sortByFieldArray, SetSortByFieldArray] = useState([]);
    const [filtersApplied, setFiltersApplied] = useState(false);
    const handleClose = () => {
        setShowFilterModal(false);
        if (!filtersApplied)
            setFiltersInput({});
    };
    const handleShow = () => setShowFilterModal(true);
    const FormatTableColumns = (metaPayload) => {
        const formattedColumns = [];
        metaPayload === null || metaPayload === void 0 ? void 0 : metaPayload.forEach((meta) => {
            if (!meta.isColVisible)
                return;
            const column = { Header: "", accessor: meta.fieldName };
            if (meta.sort) {
                column.Header = React.createElement("div", { className: "d-flex justify-content-center align-items-center" },
                    meta.colName,
                    React.createElement("div", { className: "d-inline-flex flex-column ms-2 gap-2 sorting-buttons" },
                        React.createElement(AiFillCaretUp, { onClick: () => handleSortByField({ fieldName: meta.fieldName, orderBy: "asc" }), className: `cursor-pointer p-0 m-0 ${meta.fieldName}-asc arrow-up`, size: 12 }),
                        React.createElement(AiFillCaretDown, { onClick: () => handleSortByField({ fieldName: meta.fieldName, orderBy: "desc" }), className: `cursor-pointer p-0 m-0 ${meta.fieldName}-desc arrow-down`, size: 12 })));
            }
            else
                column.Header = meta.colName;
            switch (meta.fieldName) {
                case "severity":
                    column.Cell = ({ cell: { value } }) => React.createElement(AlertBadge, { type: value, text: value, className: "alert_badges" });
                    break;
                case "status":
                    column.Cell = ({ cell: { value } }) => React.createElement(AlertBadge, { type: value, text: value, className: "alert_badges" });
                    break;
                default:
                    break;
            }
            formattedColumns.push(column);
        });
        return formattedColumns;
    };
    const getAlertsData = (params, sort, meta) => __awaiter(void 0, void 0, void 0, function* () {
        var _d, _e, _f;
        let jsonResponse = {
            success: true,
            data: {
                results: [],
                meta: { pageNum: 1, numRecords: 1, totalNumRecords: 1, hasMoreRecords: false }
            }
        };
        if (mockedData === null || mockedData === void 0 ? void 0 : mockedData.alertList)
            jsonResponse.data = mockedData.alertList;
        else {
            const response = yield fetch(`${alertsBackendUrl}${API.PATHS.LIST}`, {
                method: "POST",
                mode: "cors",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    authorization: `Bearer ${TokenManager.getInstance().getAccessToken()}`
                },
                body: JSON.stringify({
                    filter: (params === null || params === void 0 ? void 0 : params.filter((param) => param.fieldName && param.val)) || [],
                    sort: (sort === null || sort === void 0 ? void 0 : sort.length) ? sort : sortByFieldArray,
                    meta: {
                        pageNum: (meta === null || meta === void 0 ? void 0 : meta.pageNum) || 1,
                        numRecords: (meta === null || meta === void 0 ? void 0 : meta.numRecords) || perPageCount
                    }
                })
            });
            if (!response.ok)
                throw new Error("Unable to get alerts data");
            if (response.status === 204)
                throw new Error("No content received");
            jsonResponse = (yield response.json());
        }
        setAlertsResponse({
            results: (_e = (_d = jsonResponse === null || jsonResponse === void 0 ? void 0 : jsonResponse.data) === null || _d === void 0 ? void 0 : _d.results) === null || _e === void 0 ? void 0 : _e.map((alertResult) => {
                const modifiedResult = {};
                Object.entries(alertResult).forEach(([key, value]) => {
                    modifiedResult[key] = value !== null && value !== void 0 ? value : "NA";
                    if (key === "alertTimestamp") {
                        modifiedResult[key] = value ? new Date(value).toLocaleString() : "NA";
                    }
                });
                return modifiedResult;
            }),
            meta: (_f = jsonResponse.data) === null || _f === void 0 ? void 0 : _f.meta
        });
    });
    const getAlertsMetaData = () => __awaiter(void 0, void 0, void 0, function* () {
        let jsonResponse = {
            success: true,
            data: []
        };
        if (mockedData === null || mockedData === void 0 ? void 0 : mockedData.alertsMeta)
            jsonResponse.data = mockedData.alertsMeta;
        else {
            const response = yield fetch(`${alertsBackendUrl}${API.PATHS.META}`, {
                method: "POST",
                mode: "cors",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    authorization: `Bearer ${TokenManager.getInstance().getAccessToken()}`
                },
                body: JSON.stringify({ fieldName: columns })
            });
            if (!response.ok)
                throw new Error("Unable to get alerts data");
            jsonResponse = (yield response.json());
        }
        setColumnMeta(FormatTableColumns(jsonResponse.data));
        setAlertsMeta(jsonResponse.data);
    });
    const getFilteredAlerts = (sort, pagination, applyFilterInputs = true) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setIsLoading(true);
            const finalFilterList = [];
            applyFilterInputs && Object.entries(filtersInputs).map(([fieldName, paramsArray]) => {
                if (paramsArray.length && !(queryParams === null || queryParams === void 0 ? void 0 : queryParams.find((param) => param.fieldName === fieldName))) {
                    paramsArray.forEach(({ value, compareType }) => {
                        finalFilterList.push({
                            fieldName,
                            val: value,
                            compare: compareType || "strictEqual",
                        });
                    });
                }
            });
            queryParams === null || queryParams === void 0 ? void 0 : queryParams.forEach((param) => {
                if (param.fieldName && param.val && param.compare)
                    finalFilterList.push(param);
            });
            const sortingCriteria = [
                { fieldName: "alertTimestamp", orderBy: "asc" },
                { fieldName: "alertId", orderBy: "asc" },
                ...(sort === null || sort === void 0 ? void 0 : sort.length) ? sort : sortByFieldArray
            ];
            yield getAlertsData(finalFilterList, sortingCriteria, pagination);
            setIsLoading(false);
        }
        catch (error) {
            setAlertsResponse({
                results: [],
                meta: { pageNum: 1, numRecords: 0, totalNumRecords: 0, hasMoreRecords: false }
            });
            setIsLoading(false);
            // console.log({ getFilteredAlertsError: error });
        }
    });
    const handleApplyingFilters = () => {
        setFiltersApplied(true);
        getFilteredAlerts();
        setShowFilterModal(false);
    };
    const handleResettingFilters = () => {
        setFiltersInput({});
        getFilteredAlerts(undefined, undefined, false);
        setFiltersApplied(false);
    };
    const handleSortByField = (sortMeta) => {
        var _a, _b, _c;
        let newSortByFieldArray = [];
        if (sortMeta.orderBy === "asc")
            (_a = document.querySelector(`.${sortMeta.fieldName}-desc`)) === null || _a === void 0 ? void 0 : _a.classList.remove("active");
        if (sortMeta.orderBy === "desc")
            (_b = document.querySelector(`.${sortMeta.fieldName}-asc`)) === null || _b === void 0 ? void 0 : _b.classList.remove("active");
        (_c = document.querySelector(`.${sortMeta.fieldName}-${sortMeta.orderBy}`)) === null || _c === void 0 ? void 0 : _c.classList.add("active");
        SetSortByFieldArray((prev) => {
            const fieldIndex = prev.findIndex(({ fieldName }) => fieldName === sortMeta.fieldName);
            if (fieldIndex > -1 && prev[fieldIndex].orderBy === sortMeta.orderBy)
                return prev;
            newSortByFieldArray = [...prev];
            if (fieldIndex > -1)
                newSortByFieldArray[fieldIndex].orderBy = sortMeta.orderBy;
            else
                newSortByFieldArray = [...prev, { fieldName: sortMeta.fieldName, orderBy: sortMeta.orderBy }];
            return newSortByFieldArray;
        });
    };
    const initAlerts = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setIsLoading(true);
            yield Promise.all([
                getAlertsData(queryParams === null || queryParams === void 0 ? void 0 : queryParams.filter((param) => param.fieldName && param.val), [
                    { fieldName: "alertTimestamp", orderBy: "asc" },
                    { fieldName: "alertId", orderBy: "asc" }
                ]),
                getAlertsMetaData()
            ]);
            setIsLoading(false);
        }
        catch (error) {
            // console.log({ initAlertsError: error })
            setIsLoading(false);
        }
    });
    useEffect(() => {
        initAlerts();
        return () => {
            setAlertsResponse({
                results: [],
                meta: {
                    pageNum: 1,
                    numRecords: 1,
                    totalNumRecords: 0,
                    hasMoreRecords: false,
                }
            });
            setAlertsMeta([]);
        };
    }, []);
    useEffect(() => {
        if (sortByFieldArray.length)
            getFilteredAlerts(sortByFieldArray);
    }, [sortByFieldArray]);
    return (React.createElement("div", { className: "alerts-ui" },
        React.createElement("div", { className: "ms-1 me-1 mb-3 d-flex justify-content-between align-items-center" },
            React.createElement("div", null,
                React.createElement("h2", { className: "mb-0" },
                    React.createElement("b", null, heading || "Alerts"))),
            React.createElement("div", { className: "alerts-heading-icons" },
                React.createElement(Button, { variant: "primary", size: "sm", onClick: handleShow, disabled: !alertsMeta.length },
                    React.createElement("div", { className: "mx-auto my-1" },
                        " Filters ",
                        React.createElement(SlEqualizer, { size: 20, className: "ms-2" }))),
                React.createElement(Modal, { show: showFilterModal, title: React.createElement("div", { className: "ms-2 me-auto mb-0" },
                        React.createElement(SlEqualizer, { size: 20 }),
                        " ",
                        React.createElement("span", { style: { "fontSize": "1.3rem" } },
                            React.createElement("b", null, "Filters"))), onHide: handleClose, size: "lg", modalClassName: "filter-selection-modal", visibleCloseButton: true },
                    React.createElement("div", { className: "d-flex justify-content-center align-items-center flex-column mt-4" },
                        React.createElement("div", { className: "filter-selection-tab overflow-hidden" },
                            React.createElement(Tab.Container, { id: "left-tabs-example", defaultActiveKey: (_b = alertsMeta[0]) === null || _b === void 0 ? void 0 : _b.fieldName },
                                React.createElement(Row, null,
                                    React.createElement(Col, { sm: 3, className: "pe-0 border-end" },
                                        React.createElement("div", { className: "overflow-y-only height-250" },
                                            React.createElement(Nav, { variant: "pills", className: "flex-column" }, alertsMeta.filter((meta) => (meta.searchable && !(queryParams === null || queryParams === void 0 ? void 0 : queryParams.find((param) => param.fieldName === meta.fieldName))))
                                                .map((alertMeta, index) => {
                                                var _a, _b;
                                                return (React.createElement(Nav.Item, { key: index, className: "border-top" },
                                                    React.createElement(Nav.Link, { eventKey: alertMeta.fieldName, className: "d-flex px-3" },
                                                        React.createElement("span", { title: alertMeta.colName, className: "text-truncate d-inline-block w-100" },
                                                            alertMeta.colName,
                                                            " ",
                                                            " "),
                                                        ((_a = filtersInputs[alertMeta.fieldName]) === null || _a === void 0 ? void 0 : _a.length) ? React.createElement(Form.Check, { className: "d-inline-block ms-auto active-filter-radio-button", type: "radio", checked: !!((_b = filtersInputs[alertMeta.fieldName]) === null || _b === void 0 ? void 0 : _b.length), readOnly: true }) : null)));
                                            })))),
                                    React.createElement(Col, { sm: 9, className: "ps-0" },
                                        React.createElement("div", { className: "overflow-y-only height-250" },
                                            React.createElement(Tab.Content, { className: "" }, alertsMeta.map((alertMeta, index) => {
                                                return (React.createElement(Tab.Pane, { key: index, eventKey: alertMeta.fieldName, className: "w-100" },
                                                    React.createElement(Filter, Object.assign({}, alertMeta, { filterInputs: filtersInputs, setFiltersInput: setFiltersInput }))));
                                            }))))))),
                        React.createElement("div", { className: "d-flex justify-content-between mt-3 gap-3" },
                            React.createElement(Button, { className: "reset-button", variant: "light", onClick: handleResettingFilters }, "Reset"),
                            React.createElement(Button, { className: "apply-button", variant: "primary", onClick: handleApplyingFilters }, "Apply")))))),
        React.createElement(DataTable, { columns: columnMeta, data: alertsResponse === null || alertsResponse === void 0 ? void 0 : alertsResponse.results, total: ((_c = alertsResponse === null || alertsResponse === void 0 ? void 0 : alertsResponse.results) === null || _c === void 0 ? void 0 : _c.length) || 0, isLoading: isLoading, columnNames: alertsMeta.reduce((prev, { fieldName, colName }) => (Object.assign(Object.assign({}, prev), { [fieldName]: colName })), {}) }),
        React.createElement(Pagination, { paginationMeta: alertsResponse.meta, handlePagination: getFilteredAlerts, isLoading: isLoading, perPageCount: perPageCount, setPerPageCount: setPerPageCount })));
};
export default AlertsTable;
